import { BACKEND_HTTP_PATH } from 'src/config';
import { l } from 'src/utils';

const data = {
  incomingCall: false,
  session: false,
  online: false,
  currentCall: null,
};

const actions = {
  setOnline({ commit }) {
    commit('SET_ONLINE', true);
  },
  setOffline({ commit }) {
    commit('SET_ONLINE', false);
  },
  answerCallback({ commit }, sessionInfo) {
    try {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${BACKEND_HTTP_PATH}webhooks/event_tracker/voice_call`, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(sessionInfo));
      commit('SET_CURRENT_CALL', sessionInfo.call_id);
      commit('SET_INCOMING_CALL', false);
      commit('SET_SESSION', true);
    } catch (err) {
      l.error(err);
      throw err;
    }
  },
  hangupCallback({ commit }, activityInfo) {
    try {
      if (activityInfo.activity_id) {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', `${BACKEND_HTTP_PATH}webhooks/event_tracker/voice_call`, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify(activityInfo));
      }
      commit('SET_CURRENT_CALL', null);
      commit('SET_INCOMING_CALL', false);
      commit('SET_SESSION', false);
    } catch (err) {
      l.error(err);
      throw err;
    }
  },
  incomingCallback({ commit }) {
    commit('SET_INCOMING_CALL', true);
  },
};

const mutations = {
  SET_INCOMING_CALL(state, value) {
    state.incomingCall = value;
  },
  SET_SESSION(state, value) {
    state.session = value;
  },
  SET_ONLINE(state, value) {
    state.online = value;
  },
  SET_CURRENT_CALL(state, value) {
    state.currentCall = value;
  },
};

const store = {
  namespaced: true,
  state: data,
  mutations,
  actions,
};

export default store;
